export const brands = [
  {
    mono: "assets/home/brands/mc-stilotex.svg",
    color: "assets/home/brands/stilotex.svg",
    alt: "Stilotex"
  },
  {
    mono: "assets/home/brands/mc-fantasyfarms.svg",
    color: "assets/home/brands/fantasyfarms.svg",
    alt: "Fantasy Farms"
  },
  {
    mono: "assets/home/brands/mc-drbrowns.svg",
    color: "assets/home/brands/drbrowns.svg",
    alt: "Dr Browns"
  },
  {
    mono: "assets/home/brands/mc-moreproducts.svg",
    color: "assets/home/brands/moreproducts.svg",
    alt: "More Products"
  },
  {
    mono: "assets/home/brands/mc-farmatodo.svg",
    color: "assets/home/brands/farmatodo.svg",
    alt: "Farmatodo"
  },
  {
    mono: "assets/home/brands/mc-alkosto.svg",
    color: "assets/home/brands/alkosto.svg",
    alt: "Alkosto"
  },
  {
    mono: "assets/home/brands/mc-renting.svg",
    color: "assets/home/brands/renting.svg",
    alt: "Renting"
  },
  {
    mono: "assets/home/brands/mc-bium.svg",
    color: "assets/home/brands/bium.svg",
    alt: "Bium"
  },
  {
    mono: "assets/home/brands/mc-zuru.svg",
    color: "assets/home/brands/zuru.svg",
    alt: "Zuru"
  },
  {
    mono: "assets/home/brands/mc-vta.svg",
    color: "assets/home/brands/vta.svg",
    alt: "VTA"
  },
  {
    mono: "assets/home/brands/mc-toylogic.svg",
    color: "assets/home/brands/toylogic.svg",
    alt: "Toy Logic"
  },
  {
    mono: "assets/home/brands/mc-rascals.svg",
    color: "assets/home/brands/rascals.svg",
    alt: "Rascals"
  },
  {
    mono: "assets/home/brands/mc-ferrenovo.svg",
    color: "assets/home/brands/ferrenovo.svg",
    alt: "Ferrenovo"
  }
];
